module.exports = __webpack_public_path__ + "static/gate-a38c0aea036ae627cd1492831fa6c9eb.jpg";